import api from 'api';

export const loadCompanies = api('GET /api/users/filters/companies');
export const loadStudios = api('GET /api/users/filters/studios');
export const loadDepartments = api('GET /api/users/filters/departments');
export const loadManagers = api('GET /api/users/filters/managers');

export const loadActions = api('GET /api/users/filters/actions');
export const loadAffiliates = api('GET /api/users/filters/affiliates');

export const loadNetworks = api('GET /api/users/filters/networks');
export const loadApplications = api('GET /api/users/filters/applications');

export const loadFilterOptions = api('GET /api/users/filters/filter-options');
